import { pol } from '@0xtorch/core'
import { polygon } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createPolygonPosChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}) =>
  createPolygonPosChainCustom({
    client: createClient({
      chain: polygon,
      httpRpcs: polygonPosHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'PolygonScan',
      baseUrl: 'https://polygonscan.com',
      chainId: 137,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreatePolygonPosChainParameters = {
  client: Client
  explorer: Explorer
}

export const createPolygonPosChainCustom = ({
  client,
  explorer,
}: CreatePolygonPosChainParameters): Chain => ({
  id: 137,
  network: 'polygon-pos',
  name: 'Polygon PoS',
  nativeToken: {
    name: 'POL',
    symbol: 'POL',
    decimals: 18,
    currency: pol,
  },
  wrappedTokenAddresses: new Set([
    '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
  ]),
  explorer,
  client,
  blockTime: 2000,
  coingeckoId: 'polygon-pos',
  defillamaId: 'polygon',
})

export const polygonPosHttpRpcs: HttpRpc[] = [
  // Not archiving receipts
  // {
  //   url: 'https://endpoints.omniatech.io/v1/matic/mainnet/public',
  //   getLogsIsUsable: false,
  //   getLogsMaxBlockRange: 0n,
  // },
  {
    url: 'https://rpc-mainnet.matic.quiknode.pro',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  // Not archiving receipts
  // {
  //   url: 'https://polygon-pokt.nodies.app',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://1rpc.io/matic',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  // Not archiving receipts
  // {
  //   url: 'https://polygon-mainnet.rpcfast.com?api_key=xbhWBI1Wkguk8SNMu1bvvLurPGLXmgwYeC4S6g2H7WdwFigZSmPWVZRxrskEQwIf',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://polygon-bor-rpc.publicnode.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://polygon-mainnet.g.alchemy.com/v2/demo',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  // Not archiving receipts
  // {
  //   url: 'https://polygon.blockpi.network/v1/rpc/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 1024n,
  // },
  {
    url: 'https://polygon.api.onfinality.io/public',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 2000n,
  },
  // Not archiving receipts
  // {
  //   url: 'https://polygon.rpc.blxrbdn.com/',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://polygon.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://polygon.gateway.tenderly.co',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 20_000n,
  },
  {
    url: 'https://gateway.tenderly.co/public/polygon',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 20_000n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://api.zan.top/node/v1/polygon/mainnet/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://polygon.meowrpc.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://public.stackup.sh/api/v1/node/polygon-mainnet',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://polygon-mainnet.gateway.tatum.io',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://polygon.rpc.subquery.network/public',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const polygonPosWebsocketRpcUrls: readonly string[] = [
  'wss://polygon-bor.publicnode.com',
]
